import type { Ref } from "vue";

export const useStatePatcher =
  <T>(state: Ref<T>): ((partialState: Partial<T>) => void) =>
  (partialState: Partial<T>) =>
    (state.value = { ...state.value, ...partialState });
